import { ContractPropertyName } from '../../../constants';
import { Helper } from '../Helper';
export class SetDeployedHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitPushBoolean(node, true);
        sb.emitHelper(node, options, sb.helpers.wrapBoolean);
        sb.emitPushString(node, ContractPropertyName.deployed);
        sb.emitHelper(node, options, sb.helpers.putCommonStorage);
    }
}

//# sourceMappingURL=SetDeployedHelper.js.map
